'use client';

import getPathRatio from './utils/getPathRatio';
import Path from './utils/Path';
import classNames from '@/external/classNames';

type Props = {
  value?: number;
  size?: 'sm' | 'md';
};

const CircularProgress: FC<Props> = ({ value = 0, size = 'md' }) => {
  const PATH_RADIUS = 46;
  const pathRatio = getPathRatio(value);

  const sizeClass = size === 'sm' ? 'w-8 h-8' : 'w-10 h-10';

  return (
    <svg
      viewBox="0 0 100 100"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={value}
      role="progressbar"
      className={classNames(sizeClass)}
    >
      <Path
        dashRatio={1}
        pathRadius={PATH_RADIUS}
        classes="background stroke-[0.5rem] stroke-trunks/[.24]"
      />
      <Path
        dashRatio={pathRatio}
        pathRadius={PATH_RADIUS}
        classes="progress stroke-[0.5rem] rtl:-scale-x-100 rtl:translate-x-full stroke-piccolo transition-[stroke-dashoffset]"
      />
    </svg>
  );
};

export default CircularProgress;
